export default {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    setData (state, data) {
      state.data = data;
    },
  },
  getters: {
    data: state => {
      return state.data
    },
    total: state => {
      return state.data.length
    },
    getItemById: state => (id) => {
      return state.data.find(item => item.id === id);
    }
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/serviceProviders.js